import { LAYOUTS } from "@voltmoney/types";
import { WIDGET, } from "@voltmoney/schema";
import { ROUTE } from "../../../routes";
import { ACTION } from "./types";
import { goBack, navigateToForeclsure, navigateToPayment, trackFaq } from "./action";
import { getContactUsDetails } from "../../../configs/utils";
import SharedPropsService from "../../../SharedPropsService";
import { LENDER_ID } from "../../../configs/constants";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
export const template = (height, contactUsDetails, data, title, interestDueDate, creditLimit, interestRate) => {
    return {
        layout: {
            id: ROUTE.FAQ_DETAILS_SCREEN,
            type: LAYOUTS.LIST,
            style: {
                isPartnerPlatform: true
            },
            widgets: [
                {
                    id: 'faqDetailsScreen', type: WIDGET.FAQ_DETAILS_SCREEN,
                },
            ],
        },
        datastore: {
            faqDetailsScreen: {
                height,
                contactUsDetails,
                data,
                title,
                interestDueDate,
                creditLimit,
                interestRate,
                goBackAction: {
                    type: ACTION.BACK_BUTTON,
                    payload: {},
                    routeId: ROUTE.FAQ_DETAILS_SCREEN,
                },
                navigateToPayment: {
                    type: ACTION.NAVIGATE_TO_PAYMENT,
                    payload: {},
                    routeId: ROUTE.FAQ_DETAILS_SCREEN,
                },
                navigateToForeclosureScreen: {
                    type: ACTION.NAVIGATE_TO_FORECLOSURE,
                    payload: {},
                    routeId: ROUTE.FAQ_DETAILS_SCREEN,
                },
                trackFaqInstrumentAction: {
                    type: ACTION.FAQ_INSTRUMENT,
                    payload: {},
                    routeId: ROUTE.FAQ_DETAILS_SCREEN,
                }
            }
        },
    };
};
export const faqDetailsScreenMf = {
    onLoad: async ({ getHeight, network }, { data, title }) => {
        const contactUsDetails = await getContactUsDetails();
        const user = await SharedPropsService.getUser();
        const creditId = user?.linkedCredits[0]?.creditId;
        const lenderId = user?.linkedCredits[0]?.lendingPartnerId;
        const interestDueDate = lenderId?.toLowerCase() === LENDER_ID.TATA ? '3rd' : '7th';
        const getLoanDetails = await network.get(`${api.getLoanDetails}${creditId}`, { headers: await getAppHeader() });
        const loanDetailsObj = getLoanDetails?.data;
        const creditLimit = loanDetailsObj?.loanDetails?.actualLoanAmount;
        const interestRate = loanDetailsObj?.interestDetails?.interestRate;
        return Promise.resolve(template(getHeight(), contactUsDetails, data, title, interestDueDate, creditLimit, interestRate));
    },
    actions: {
        [ACTION.BACK_BUTTON]: goBack,
        [ACTION.NAVIGATE_TO_PAYMENT]: navigateToPayment,
        [ACTION.NAVIGATE_TO_FORECLOSURE]: navigateToForeclsure,
        [ACTION.FAQ_INSTRUMENT]: trackFaq,
    },
};
